export const getData = async ({ url, onResponse }) => {

    try {
        const res = await fetch(`/json/${url}`);
        if (!res.ok) onResponse(false, null);
        const data = await res.json();
        onResponse(true, data)
    } catch (err) {
        console.error(`getData(${url})`, err);
        onResponse(false, null)
    }
}